import React, { useState } from 'react';
import CouponCard from './CouponCard';
import { Coupon } from './coupon';
import styled from 'styled-components';
import UseCouponModal from './UseCouponModal';
import Pagination from '../../components/pagination/Pagination';
import { useUser } from '../../../context/UserContext';

interface Props {
  activeTab: string;
  couponList: Coupon[];
  getList: () => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalCount: number;
}

function CouponList({
  activeTab,
  couponList,
  getList,
  currentPage,
  setCurrentPage,
  totalCount,
}: Props) {
  const { refreshUser } = useUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState<number | null>(null);

  const handleUseClick = (coupon: Coupon) => {
    setIsModalOpen(true);
    setSelectedCoupon(coupon.coupon_history_id);
  };

  const handleCouponUse = () => {
    if (!selectedCoupon) return;
    setIsModalOpen(false);
    setSelectedCoupon(null);
    getList();
    refreshUser();
  };
  return (
    <Container>
      {couponList.map((c) => (
        <CouponCard
          coupon={c}
          isUsed={activeTab === '사용 완료'}
          onUseClick={handleUseClick}
        />
      ))}
      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(totalCount / 10)}
        onPageChange={setCurrentPage}
      />

      {selectedCoupon && isModalOpen && (
        <UseCouponModal
          couponId={selectedCoupon}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleCouponUse}
        />
      )}
    </Container>
  );
}

export default CouponList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px 0;
`;
